import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import { MenuOutlined } from '@ant-design/icons'; // Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGlobe,
  faGauge,
  faUser,
  faGears,
  faHandsAslInterpreting,
  faDiagramProject,
  faClipboardList,
  faCaretDown,
  faCaretUp,
} from '@fortawesome/free-solid-svg-icons'; // Import the specific icon
import logo from '../../assets/WhatsApp_Image_2025-01-20_at_9.35.44_pm-4-removebg-preview.png';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [vendorOpen, setVendorOpen] = useState(false);
  const [projectManagementOpen, setProjectManagementOpen] = useState(false);

  const toggleUserManagement = () => setUserManagementOpen(!userManagementOpen);
  const toggleSettings = () => setSettingsOpen(!settingsOpen);
  const toggleVendor = () => setVendorOpen(!vendorOpen);
  const toggleProjectManagement = () => setProjectManagementOpen(!projectManagementOpen);

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-logo">
        <img src={logo} alt="Admin Panel Logo" className="sidebar-logo-image" /> {/* Logo Image */}
        <button onClick={toggleSidebar} className="sidebar-togglee">
          <MenuOutlined />
        </button>
      </div>
      <nav className="sidebar-nav">
        <NavLink to="/" className="sidebar-link" activeClassName="active">
          <FontAwesomeIcon icon={faGauge} style={{ marginRight: '10px' }} />
          Dashboard
        </NavLink>

        {/* User Management Dropdown */}
        <div className="sidebar-dropdown">
          <div className="sidebar-link" onClick={toggleUserManagement}>
            <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} />
            User Management
            <FontAwesomeIcon
              icon={userManagementOpen ? faCaretUp : faCaretDown}
              style={{ marginLeft: 'auto' }}
            />
          </div>
          {userManagementOpen && (
            <div className="dropdown-content">
              <NavLink to="/admins" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} />
                Admins
              </NavLink>
              <NavLink to="/clients" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} />
                Clients
              </NavLink>
            </div>
          )}
        </div>

        {/* Settings Dropdown */}
        <div className="sidebar-dropdown">
          <div className="sidebar-link" onClick={toggleSettings}>
            <FontAwesomeIcon icon={faGears} style={{ marginRight: '10px' }} />
            Settings
            <FontAwesomeIcon
              icon={settingsOpen ? faCaretUp : faCaretDown}
              style={{ marginLeft: 'auto' }}
            />
          </div>
          {settingsOpen && (
            <div className="dropdown-content">
              <NavLink to="/languages" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faGlobe} style={{ marginRight: '10px' }} />
                Languages
              </NavLink>
              <NavLink to="/services" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faGears} style={{ marginRight: '10px' }} />
                Services
              </NavLink>
            </div>
          )}
        </div>

        {/* Vendor Dropdown */}
        <div className="sidebar-dropdown">
          <div className="sidebar-link" onClick={toggleVendor}>
            <FontAwesomeIcon icon={faHandsAslInterpreting} style={{ marginRight: '10px' }} />
            Vendor
            <FontAwesomeIcon
              icon={vendorOpen ? faCaretUp : faCaretDown}
              style={{ marginLeft: 'auto' }}
            />
          </div>
          {vendorOpen && (
            <div className="dropdown-content">
              <NavLink to="/translators" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faHandsAslInterpreting} style={{ marginRight: '10px' }} />
                Vendor
              </NavLink>
            </div>
          )}
        </div>

        {/* Project Management Dropdown */}
        <div className="sidebar-dropdown">
          <div className="sidebar-link" onClick={toggleProjectManagement}>
            <FontAwesomeIcon icon={faDiagramProject} style={{ marginRight: '10px' }} />
            Project Management
            <FontAwesomeIcon
              icon={projectManagementOpen ? faCaretUp : faCaretDown}
              style={{ marginLeft: 'auto' }}
            />
          </div>
          {projectManagementOpen && (
            <div className="dropdown-content">
              <NavLink to="/projects" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faDiagramProject} style={{ marginRight: '10px' }} />
                Projects
              </NavLink>
              <NavLink to="/pending-projects" className="dropdown-item" activeClassName="active">
                <FontAwesomeIcon icon={faClipboardList} style={{ marginRight: '10px' }} />
                Pending Projects
              </NavLink>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;